import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { FormSearchComponent } from '../../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { LegalEntityClientService } from '../../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  PagedContactTypeResponse,
} from '../../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { ClientCreateComponent } from '../../client-create/client-create.component'
import { LegalEntityClientComponent } from '../../../../pages/customer/legal-entity-client/legal-entity-client.component'
import { MatTab } from '@angular/material/tabs'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../../shared/utils/utils'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { SubClientCreateComponent } from '../../sub-client/sub-client-create/sub-client-create.component'
import { MatSelectChange } from '@angular/material/select'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'

@Component({
  selector: 'modal-legal-entity-client-subclient',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    LegalEntityClientComponent,
    MatTab,
    FormClientSearchComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './modal-legal-entity-client-subclient.component.html',
  styleUrl: './modal-legal-entity-client-subclient.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class ModalLegalEntityClientSubClientComponent implements OnInit {
  constructor(
    private legalEntityClientService: LegalEntityClientService,
    private dialogRef: MatDialogRef<ModalLegalEntityClientSubClientComponent>,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      if (data.item && data.item.id && data.item.id !== -1) {
        this.selected = data.item
      }

      if (data.subClient) {
        this.subClient = data.subClient
      }
      // this.selected = data.item
      // if (data.subClient) {
      //   this.subClient = data.subClient
      // }
    }
    if (data.create) {
      this.createBtn = true
    }
  }

  subClient = false
  multiSelect = false

  createBtn = false

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  form: FormGroup = new FormGroup({})

  listSearch: any = [
    { id: 'nomeFantasia', description: 'Nome', type: 'string', visible: true },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'inscricaoMunicipal',
      description: 'Inscrição Municipal',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoEstadual',
      description: 'Inscrição Estadual',
      type: 'string',
      visible: false,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome Fantasía',
    },
    {
      keyColumn: 'corporateReason',
      key: 'razaoSocial',
      description: 'Razão social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ',
    },
  ]
  screen = 'status operação'

  listFiler: any[] = [
    { value: 1, description: 'Cliente' },
    { value: 2, description: 'SubCliente' },
  ]

  ngOnInit() {
    this.createForm()
    this.getListItems()
  }

  close() {
    this.dialogRef.close()
  }

  createForm() {
    this.form = this.formBuilder.group({
      filter: [1],
    })
    if (this.subClient) {
      this.form.get('filter')?.setValue(2)
    }
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = { filter: this.subClient ? 2 : 1 }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.legalEntityClientService
      .listPagedClientSubClient(this.page, this.rows, this.subClient ? 2 : 1)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.legalEntityClientService
      .searchPagedClientSubClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      const index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1, description: '', subClient: false }
      } else {
        this.selected = event
      }
    }
  }

  checkForm() {
    if (this.selected.id >= 0 || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: true })
    } else {
      this.responseSingle.emit({ remove: true })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: false, selection: this.listSelected })
    } else {
      this.responseSingle.emit({
        remove: false,
        selection: this.selected,
        subClient: this.subClient,
      })
    }
    this.close()
  }

  editItem(event: any) {
  }

  deleteItem(event: any) {
  }

  onSelectionChangeFilter(event: MatSelectChange) {
    if (event.value == 1) {
      this.subClient = false
    } else if (event.value == 2) {
      this.subClient = true
    }
    if (this.searchForm.search) {
      this.searchForm.model.filter = this.subClient ? 2 : 1
    }
    this.selected = { id: -1, description: '', subClient: this.subClient }
    this.uploadList()
  }

  newClient() {
    if (!this.subClient) {
      const dialogRef = this.dialog.open(ClientCreateComponent, {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '100vw',
        width: '100vw',
        maxHeight: '100vh',
        height: '100vh',
        panelClass: 'dialog-fullscreen',
        data: { modal: true },
      })
      dialogRef.componentInstance.responseModal.subscribe((response) => {
        this.uploadList()
      })
    } else {
      const dialogRef = this.dialog.open(SubClientCreateComponent, {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '100vw',
        width: '100vw',
        maxHeight: '100vh',
        height: '100vh',
        panelClass: 'dialog-fullscreen',
        data: { modal: true },
      })
      dialogRef.componentInstance.responseModal.subscribe((response) => {
        this.uploadList()
      })
    }
  }
}
